import {
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
  NAME_VALIDATION_MESSAGES,
} from '@azymmetric/shared/validation/validation.constants';
import { zCoercedOptional, zFilteredStringArray } from '@utils/zodv4.util';
import { z } from 'zod/v4';

export const domainSchema = z.object({
  name: z
    .string()
    .min(NAME_MIN_LENGTH, { message: NAME_VALIDATION_MESSAGES.min })
    .max(NAME_MAX_LENGTH, { message: NAME_VALIDATION_MESSAGES.max }),
  parentDomainId: zCoercedOptional(z.uuid({ message: 'Please select a valid parent domain.' }).nullable().optional()),
  subdomains: zFilteredStringArray(z.array(z.uuid())),
});

export type DomainSchema = z.infer<typeof domainSchema>;
